import IRoutes from "../interfaces/IRoutes";
import Company from "../pages/company/Company";
import CompanyField from "../pages/company/CompanyField";

const CompanyRoute: Array<IRoutes> = [
  {
    element: <Company />,
    path: "/company",
  },
  {
    element: <CompanyField />,
    path: "/company/create",
  },
  {
    element: <CompanyField />,
    path: "/company/edit/:id",
  },
];

export { CompanyRoute };
